export const createUserSlice = (set) => ({
  userMobileNumber: "",
  mobileToken: "",
  userToken: "",
  refreshToken: "",
  fcmToken: "",
  userInfo: "",
  userStatus: "",
  locationDetails: {},
  appDetails: {},
  verifiedMobileNumber: "",
  isDummyUser: false,
  storeIsDummyUser: (status) => set({ isDummyUser: status }),
  storeAppDetails: (details) => set({ appDetails: details }),
  storeLocationDetails: (details) => set({ locationDetails: details }),
  storeUserStatus: (userStatus) => {
    set({
      userStatus: userStatus,
    });
  },
  removeUserStatus: () => set({ userStatus: "" }),
  storeMobileNumber: (mobileNo) => {
    set({
      userMobileNumber: mobileNo,
    });
  },
  storeVerifiedMobileNumber: (verifiedMobileNumber) => {
    set({
      verifiedMobileNumber: verifiedMobileNumber,
    });
  },
  storeMobileToken: (_mt) => set({ mobileToken: _mt }),
  removeMobileToken: () => set({ mobileToken: "" }),
  storeUserTokens: (_ta, _tr) => set({ userToken: _ta, refreshToken: _tr }),
  storeFcmToken: (token) => set({ fcmToken: token }),
  storeUserInfo: (userData) => set({ userInfo: userData }),
  clearAuth: () =>
    set({
      userMobileNumber: "",
      userToken: "",
      refreshToken: "",
      fcmToken: "",
      mobileToken: "",
      userInfo: "",
      appDetails: null,
      locationDetails: null,
    }),
});
